<template>
  <div class="td-links-wrap">
    <div v-if="data.status == ReportStatus.WaitingSurvey || data.status == ReportStatus.LabsWaitingSurvey" class="d-flex align-items-center justify-content-between">
      <b-btn variant="link" class="text-warning p-0" @click="$emit('on-label-click', data)">Waiting for Patient's Survey</b-btn>
      <svg-icon class="notify-icon clickable" size="32" name="notify" title="Send Notification" @click="$emit('on-notify', data)"></svg-icon>
      <svg-icon v-if="data.hasReqDocument && (
        data.labworkType === LabworkType.ClientDraw || 
        data.labworkType === LabworkType.Internal ||
        data.labworkType === LabworkType.QuestClientDraw ||
        data.labworkType === LabworkType.QuestPSC
        ) && data.status == ReportStatus.LabsWaitingSurvey"
                class="ml-1 pdf-icon req clickable"
                size="32"
                name="pdf"
                @click="$emit('on-download-req', data)" />
    </div>
    <div v-if="data.status == ReportStatus.WaitingReview" class="td-text text-warning">
      <span>Preparing Labwork Order</span>
    </div>
    <div v-if="data.status == ReportStatus.WaitingResults || data.status == ReportStatus.FinalProcessing" class="d-flex align-items-center justify-content-between">
      <b-btn variant="link" class="text-warning p-0" @click="$emit('on-label-click', data)">Waiting for Lab Result</b-btn>
      <div>
        <svg-icon class="notify-icon clickable" size="32" name="notify" title="Send Notification" @click="$emit('on-notify', data)"></svg-icon>
        <svg-icon v-if="data.hasReqDocument && (
          data.labworkType === LabworkType.ClientDraw ||
          data.labworkType === LabworkType.Internal ||
          data.labworkType === LabworkType.QuestClientDraw ||
          data.labworkType === LabworkType.QuestPSC
          )" class="ml-1 pdf-icon req clickable" size="32" name="pdf" @click="$emit('on-download-req', data)"></svg-icon>
      </div>
    </div>
    <div v-if="data.status == ReportStatus.Cancelled" class="td-text text-danger">
      <span>Cancelled</span>
    </div>
    <div v-if="data.status == ReportStatus.Completed" class="d-flex align-items-center justify-content-between">
      <b-btn variant="link" class="text-success p-0" @click="$emit('on-label-click', data)">Completed</b-btn>
      <svg-icon v-if="!$auth.isInRole('ClientOrderer')" class="pdf-icon clickable" size="32" name="pdf" @click="$emit('on-download-report', data)"></svg-icon>
    </div>
    <div v-if="data.status == ReportStatus.OrderLabsFirst" class="d-flex align-items-center justify-content-between">
      <span class="td-text text-warning">Order Labs First</span>
      <svg-icon v-if="data.hasReqDocument" class="ml-1 pdf-icon req clickable" size="32" name="pdf" @click="$emit('on-download-req', data)"></svg-icon>
    </div>
    <div v-if="data.status == ReportStatus.OrderOnHold" class="d-flex align-items-center justify-content-between">
      <b-btn variant="link" class="text-warning p-0" @click="openOptionsModal">Order On Hold</b-btn>
      <svg-icon v-if="data.hasReqDocument" class="ml-1 pdf-icon req clickable" size="32" name="pdf" @click="$emit('on-download-req', data)"></svg-icon>
    </div>

    <report-options-modal ref="reportOptionsModal" @success="actionCompleted" @cancel="onCancel" />
  </div>
</template>

<script>
  import ReportStatus from 'enums/report-status';
  import LabworkType from 'enums/labwork-type';

  import reportOptionsModal from './report-options-modal';

  export default {
    props: {
      data: Object,
    },

    components: {
      reportOptionsModal
    },

    data() {
      return {
        ReportStatus,
        LabworkType
      }
    },

    methods: {
      async openOptionsModal() {
        await this.$refs.reportOptionsModal.show(this.data.id);
      },

      actionCompleted() {
        this.$emit('redraw');
      },

      onCancel() {
        this.$root.successToast('Report cancelled!');

        this.$emit('redraw');
      }
    }
  };
</script>